import React from 'react';
import { Navigate } from 'react-router-dom';
import { withAppLayout } from '../core/routes';

export const adminRoutes = [
  { path: '/admin/backup', element: withAppLayout(<Navigate to="/settings/workspaces" replace />) },
];
